import { useEffect, useState } from "react";

/** Open state for the mobile menu; locks body scroll and closes on Escape or desktop resize. */
export function useMobileMenu() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.classList.toggle("mjm-menu-open", open);
    return () => document.body.classList.remove("mjm-menu-open");
  }, [open]);

  useEffect(() => {
    const close = () => setOpen(false);
    const onKeyDown = (event) => event.key === "Escape" && close();
    const onResize = () => window.innerWidth > 900 && close();
    window.addEventListener("keydown", onKeyDown);
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
      window.removeEventListener("resize", onResize);
    };
  }, []);

  return [open, setOpen];
}
